// extracted by mini-css-extract-plugin
export var intro = "results-module--intro--sErlO";
export var intro__second = "results-module--intro__second--3SFCX";
export var intro__wrap = "results-module--intro__wrap--1ixGh";
export var intro__section = "results-module--intro__section--2G_q9";
export var intro__section__image = "results-module--intro__section__image--16SxY";
export var info__section__image__bg = "results-module--info__section__image__bg--2U6jx";
export var intro__section__image__bg = "results-module--intro__section__image__bg--3f421";